import { ArrowUp } from 'lucide-react';
import React from 'react';

export const SendIcon = () => {
  return (
    <ArrowUp className="text-white w-[34px] h-[34px] bg-primary p-2 flex items-center justify-center rounded-full" />
  );
};
